import { render, staticRenderFns } from "./PersonalDataSection.vue?vue&type=template&id=00da2c69&scoped=true&"
import script from "./PersonalDataSection.vue?vue&type=script&lang=js&"
export * from "./PersonalDataSection.vue?vue&type=script&lang=js&"
import style0 from "./PersonalDataSection.vue?vue&type=style&index=0&id=00da2c69&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00da2c69",
  null
  
)

export default component.exports